<template>
  <fragment>
    <c-generic-section top-divider>
      <div class="container-sm">
        <h1 class="mt-0 center-content">Frequently Asked Questions</h1>

        <c-section-header :data="{title: 'General Questions'}" class="center-content pt-24" />
        <c-faq-general></c-faq-general>

        <c-section-header :data="{title: 'How the process works'}" class="center-content pt-24" />
        <c-faq-how-it-works :startOpen="false"></c-faq-how-it-works>

        <c-section-header :data="{title: 'Pricing'}" class="center-content pt-24" />
        <c-faq-pricing :startOpen="false"></c-faq-pricing>
      </div>
    </c-generic-section>
    <c-cta split />
  </fragment>
</template>

<script>
// import layout
import CLayout from "@/layouts/LayoutAlternative.vue";
// import section header
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CGenericSection from "@/components/sections/GenericSection.vue";
import CCta from "@/components/sections/Cta.vue";
// FAQs
import CFaqHowItWorks from "@/components/elements/FaqHowItWorks.vue";
import CFaqPricing from "@/components/elements/FaqPricing.vue";
import CFaqGeneral from "@/components/elements/FaqGeneral.vue";

export default {
  name: "Secondary",
  components: {
    CSectionHeader,
    CGenericSection,
    CCta,
    CFaqHowItWorks,
    CFaqPricing,
    CFaqGeneral
  },
  data() {
    return {};
  },
  created() {
    this.$emit("update:layout", CLayout);
  },
  mounted() {},
  computed: {},
  methods: {}
};
</script>

<style scoped lang="scss">
.contact-box {
  background: rgba(0, 0, 0, 0.75);
  padding: 1rem;
  margin-bottom: 1rem;

  ul {
    margin: 0;
  }
}
.msg {
  padding: 1rem;
  border-radius: 5px;
}

.msg-error {
  background: rgb(255, 203, 212);
  color: maroon;
  text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.5);

  a:hover {
    color: rgb(0, 68, 255);
  }
}
.msg-success {
  background: rgba(0, 0, 0, 0.4);
  color: white;
}
</style>